import { Reveal } from "@/components/common";
import { USE_CASES } from "@/lib/data";
import { useI18n } from "@/i18n";

// Compact application card: square image on the left, title + description on the right.
function AppCard({ i }) {
  const { t } = useI18n();
  const items = t("useCases.items");
  const u = { ...USE_CASES[i], ...items[i] };
  return (
    <div className="application-item group flex flex-col gap-4 rounded-[22px] border border-white/10 bg-white/[0.03] p-4 transition-all duration-300 hover:-translate-y-[3px] hover:border-white/25 md:flex-row md:items-center md:gap-7 md:p-7">
      <div className="application-square-image overflow-hidden">
        <img
          src={u.img}
          alt={u.alt || `${u.title} — premium vastgoedwoning`}
          loading="lazy"
          className="transition-transform duration-500 group-hover:scale-[1.05]"
        />
      </div>
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-gradient-red" />
          {u.label && (
            <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-white/45">{u.label}</span>
          )}
        </div>
        <h3 className="mt-1.5 break-words font-heading text-lg font-bold text-white md:text-xl">{u.title}</h3>
        <p className="mt-1.5 break-words text-[14px] leading-relaxed text-white/60">{u.text}</p>
      </div>
    </div>
  );
}

export function UseCases() {
  const { t } = useI18n();
  return (
    <section id="toepassingen" className="relative overflow-visible bg-[#0e0e11] py-24 md:py-32" data-testid="use-cases">
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute left-1/4 top-0 h-80 w-80 rounded-full bg-gradient-red opacity-[0.10] blur-[120px]" />
        <div className="absolute bottom-0 right-1/4 h-80 w-80 rounded-full bg-gradient-red opacity-[0.08] blur-[130px]" />
      </div>
      <div className="container-re relative">
        <Reveal className="mx-auto max-w-[900px] px-2 text-center">
          <h2 className="pb-1 font-heading text-3xl font-black leading-[1.14] tracking-tight text-white md:text-5xl">
            {t("useCases.title")} <span className="text-gradient-red">{t("useCases.titleAccent")}</span>.
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base text-white/55 md:text-lg">
            {t("useCases.sub")}
          </p>
        </Reveal>

        {/* Compact 2-col-on-desktop grid of application cards */}
        <div className="mx-auto mt-14 grid max-w-[1240px] gap-5 lg:grid-cols-2 md:gap-7">
          {USE_CASES.map((_, i) => (
            <Reveal key={i} delay={(i % 2) * 0.08 + Math.floor(i / 2) * 0.06}>
              <AppCard i={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
